module.exports = __webpack_public_path__ + "static/media/Icons-2.301c01b8.svg";